import React, { useEffect, useState } from "react";

import MenuItem from "./MenuItem";

const Menu = (props) => {
  useEffect(() => {
    setLeft(`${document.querySelector(".game-header .container-fluid")
      .getBoundingClientRect().left}px`);
  })

  const [left, setLeft] = useState("");

  return (
    <nav className={`menus rollable ${window.innerWidth < 768 ? "mm-menu" : ""}`} id="affix-menu" style={{ display: "block", left }}>
      <div>
        <ul className="menu" style={{ display: "flex", flexFlow: "column" }}>
          <MenuItem
            name="News"
            title="News"
            icon="magicka-kniha"
            h1classes={"border-bottom"}
          />
        </ul>
        <ul className="menu" style={{ display: "flex", flexFlow: "column" }}>
          <MenuItem
            label="Marketplace"
            name="AllianceStorage"
            subNames={["Marketplace"]}
            title="Alliance Storage"
            icon="trziste"
          />
          <MenuItem
            name="Development"
            title="Development"
            icon="vedci"
          />
          <MenuItem
            name="Generals"
            title="Generals"
            icon="valka"
          />
          <MenuItem
            name="Labyrinth"
            subNames={["ChooseTreasure", "GeneralsOverview", "LabyrinthResult"]}
            title="Labyrinth"
            icon="labyrint"
            h1classes={"border-bottom"}
          />
        </ul>
        <ul className="menu" style={{ display: "flex", flexFlow: "column" }}>
          <MenuItem
            name="Thieves"
            title="Thieves"
            subNames={["Thieves", "ThievesEmperorTent"]}
            icon="zlodeji"
          />
          <MenuItem
            name="Magic"
            subNames={["Magic", "MagicPlanner", "MagicEmperorTent"]}
            title="Magic"
            icon="magie"
          />
          <MenuItem
            name="Army"
            title="Army"
            subNames={["Army", "ArmyEmperorTent"]}
            icon="armada"
          />
        </ul>
        <ul className="menu" style={{ display: "flex", flexFlow: "column" }}>
          <MenuItem
            label="Overview"
            name="AllianceOverview"
            subNames={["DevelopmentOverview", "GeneralsOverview", "OverviewPalace"]}
            title="Overview"
            icon="imperator"
            disabled={!props.alliance}
          />
          <MenuItem
            name="Statistics"
            title="Statistics"
            icon="statistiky"
          />
        </ul>
      </div>
    </nav>
  )
}

export default Menu;
